import { useEffect, useState } from "react";
import api, { apiError, fmtUSD } from "../../../lib/api";
import { toast } from "sonner";

export function Commitments() {
  const [cmts, setCmts] = useState([]);
  const load = () => api.get("/admin/commitments").then((r) => setCmts(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const patch = async (c, status) => {
    let allocated_amount = null;
    if (status === "allocated") {
      const v = window.prompt("Allocated amount, USD", String(c.amount_usd));
      if (v === null) return;
      allocated_amount = Number(v);
    }
    try {
      await api.patch(`/admin/commitments/${c.commitment_id}`, { status, allocated_amount });
      toast.success("Updated.");
      load();
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <table className="table-solera" data-testid="admin-commitments-table">
      <thead><tr><th>Member</th><th>Company</th><th className="num">Committed</th><th className="num">Allocated</th><th>Status</th><th></th></tr></thead>
      <tbody>
        {cmts.map((c) => (
          <tr key={c.commitment_id}>
            <td className="text-muted-s">{c.member_email}</td>
            <td className="text-bone">{c.company}</td>
            <td className="num text-bone">{fmtUSD(c.amount_usd)}</td>
            <td className="num text-bone">{c.allocated_amount != null ? fmtUSD(c.allocated_amount) : "-"}</td>
            <td className="text-muted-s capitalize">{c.status.replace("_", " ")}</td>
            <td className="text-right whitespace-nowrap space-x-4">
              <button onClick={() => patch(c, "allocated")} className="t-label hover:!text-[#E8E6E1]" data-testid={`allocate-button-${c.commitment_id}`}>Allocate</button>
              <button onClick={() => patch(c, "cut")} className="t-label hover:!text-[#E8E6E1]">Cut</button>
              {(c.status === "funds_sent" || c.status === "allocated") && (
                <button onClick={() => patch(c, "settled")} className="t-label hover:!text-[#E8E6E1]" data-testid={`settle-button-${c.commitment_id}`}>Settle</button>
              )}
            </td>
          </tr>
        ))}
        {cmts.length === 0 && <tr><td colSpan={6} className="text-muted-s t-small py-8">No commitments yet.</td></tr>}
      </tbody>
    </table>
  );
}
